import { generatePath } from 'react-router-dom';

import { companyPaths } from 'app/constants/routes';

/**
 * Navigation targets reachable from the Reward & Recognition overview. The
 * back-office is always scoped to a managed company, so destinations resolve to
 * the company-scoped route for the given companyId.
 */
export type RecognitionDestination =
  | 'overview'
  | 'prides'
  | 'theRoar'
  | 'campaigns'
  | 'approvals'
  | 'walletsAndPots'
  | 'gifting';

const DESTINATION_PATHS: Record<RecognitionDestination, string> = {
  overview: companyPaths.recognitions.path,
  prides: companyPaths.prides.path,
  theRoar: companyPaths.theRoar.path,
  campaigns: companyPaths.campaigns.path,
  approvals: companyPaths.recognitionApprovals.path,
  walletsAndPots: companyPaths.walletsAndPots.path,
  gifting: companyPaths.gifting.path,
};

export function getRecognitionPath(destination: RecognitionDestination, companyId: string): string {
  return generatePath(DESTINATION_PATHS[destination], { companyId });
}
